<!--文件流上传-->
<template>
  <el-upload
    ref="uploaderRef"
    accept=".pem"
    action=""
    :on-change="uploadFile"
    :on-remove="remove"
    :auto-upload="false"
    :file-list="fileList">
    <el-button class="ml-1" size="small" type="primary" icon="el-icon-upload">
      {{ isUpload ? '重新上传' : '选取文件' }}
    </el-button>
  </el-upload>
</template>

<script>
import { throttle } from 'lodash'

export default {
  name: 'FileStreamUpload',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    parentInfo: {
      type: [Object, FormData],
      default: () => ({})
    },
    updateFlag: Boolean,
    uploadKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      disabled: false,
      btnDisabled: false,
      uploadFlag: true,
      headers: {
        Authorization: window.sessionStorage.getItem('token')
      },
      fileList: []
    }
  },
  computed: {
    isUpload() {
      this.$emit('update:updateFlag', this.fileList.length > 0)
      return this.fileList.length > 0
    }
  },
  methods: {
    remove() {
      this.$refs.uploaderRef.clearFiles()
      this.disabled = this.btnDisabled = false
      this.fileList = []
    },
    beforeUpload(file) {
      this.disabled = this.btnDisabled = true
      const xlsTypes = ['pem']
      const fileType = file.name.split('.')[1]
      const isXls = xlsTypes.includes(fileType)
      if (!isXls) {
        this.$message.error('仅支持.pem文件')
        this.remove()
        this.uploadFlag = this.disabled = this.btnDisabled = false
        return false
      }
    },
    uploadFile: throttle(async function(file) {
      this.beforeUpload(file)
      if (!this.uploadFlag) return
      this.$emit('update:loading', true)
      try {
        this.parentInfo.append(this.uploadKey, file.raw)
        this.fileList = [file]
      } catch (e) {
        console.error(e)
      } finally {
        this.$emit('update:loading', false)
        // this.remove()
      }
    }, 1500, {}),
    onSuccess(file) {
      console.log(file)
    }
  }
}
</script>

<style scoped>

</style>
